import { useEffect, useState } from "react";
import {
  createNews,
  getAllNews,
  updateNews,
  deleteNews,
} from "../../../api/posts";
import { UPLOAD_PRESETS_CLOUDINARY } from "../../../api";
import { uploadCloud } from "../../../api/Products";

const NewsAdmin = () => {
  const [newsList, setNewsList] = useState([]);
  
  const [form, setForm] = useState({ title: "", paragraph: "" });
  const [image, setImage] = useState(null);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch all news from API
  useEffect(() => {
    // setEditId(null); // Reset editId on mount
    const fetchNews = async () => {
      const data = await getAllNews();
      console.log(data);
      
      setNewsList(data);
    };
    fetchNews();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      let imageUrl = form.image; // In edit mode, keep existing URL

      if (image) {
        const formUpl = new FormData();
        formUpl.append("upload_preset", UPLOAD_PRESETS_CLOUDINARY);
        formUpl.append("file", image);
        formUpl.append("folder", "news");

        const uploadedImage = await uploadCloud(formUpl);
        imageUrl = uploadedImage.data.secure_url;
      }

      const payload = {
        title: form.title,
        image: imageUrl,
        paragraph: form.paragraph,
        // createdAt: new Date().toISOString(),
      };

      if (editId) {
        await updateNews(payload, editId);
      } else {
        await createNews(payload);
      }

      // Refresh news list
      const updatedNews = await getAllNews();
      setNewsList(updatedNews);

      // Reset form
      setForm({ title: "", paragraph: "" });
      setImage(null);
      setEditId(null);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (news) => {
    setForm({
      title: news.title,
      paragraph: news.paragraph,
        image: news.image, // Use existing image URL for edit
    });
    setEditId(news._id);
    setImage(news.image); // Optional: reset selected image
    // console.log(news);
  };

  const handleDelete = async (id) => {
    try {
      await deleteNews(id);
      const updatedNews = await getAllNews();
      setNewsList(updatedNews);
    } catch (error) {
      console.error("Error deleting news:", error);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">{editId ? "Edit News" : "Add News"}</h2>

      <form onSubmit={handleSubmit} className="space-y-4 mb-6">
        <input
          type="text"
          className="block w-full p-2 border rounded"
          placeholder="Title"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
        />

        <textarea
          className="block w-full p-2 border rounded"
          placeholder="Details"
          value={form.paragraph}
          onChange={(e) => setForm({ ...form, paragraph: e.target.value })}
          required
        />

        {!image && !form.image && (
          <input
            type="file"
            accept="image/*"
            className="block w-full p-2 border rounded"
            onChange={(e) => setImage(e.target.files[0])}
            required={!editId}
          />
        )}

        {(image || form.image) && (
          <div className="mt-2 relative bg-[#f0f0f0] p-4 rounded">
            {image ? (
              <>
                <p className="text-green-600 text-sm mb-1">
                  Selected file: <strong>{image.name}</strong>
                </p>
                <img
                  src={form.image ? form.image : URL.createObjectURL(image)}
                  alt="Preview"
                  className="h-32 object-cover rounded border"
                />
              </>
            ) : (
              <>
                <p className="text-sm mb-1">Current Image:</p>
                <img
                  src={form.image}
                  alt="Existing"
                  className="h-32 object-cover rounded border"
                />
              </>
            )}
            <button
              type="button"
              className="absolute top-6 right-2 text-white rounded-md p-3 bg-red-700"
              onClick={() => {
                setImage(null);
                setForm({ ...form, image: "" });
              }}
            >
              Remove
            </button>
          </div>
        )}

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded"
          disabled={loading}
        >
          {editId ? "Update News" : loading ? "Submitting..." : "Add News"}
        </button>
        {editId && (
          <button
          type="button"
          className="bg-red-600 text-white px-4 py-2 rounded"
          onClick={() => {
            setEditId(null);
            setForm({ title: "", paragraph: "", image: "" });
            setImage(null);
          }}
        >
         {"Cancel Edit"}
        </button>
        )}

      </form>

      <h2 className="text-xl font-bold mb-2">Manage News</h2>
      <ul className="space-y-4">

        {newsList?.length>0 && newsList?.map((news) => (
          <li key={news._id} className="border p-4 rounded shadow">
            <img
              src={news.image}
              className="w-full h-32 object-cover rounded mb-2"
              alt={news.title}
            />
            <h3 className="font-semibold">{news.title}</h3>
            <p className="text-sm">{news.paragraph.slice(0, 100)}...</p>
            <div className="space-x-2 mt-2">
              <button
                onClick={() => handleEdit(news)}
                className="text-blue-600 text-sm"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(news._id)}
                className="text-red-600 text-sm"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NewsAdmin;
